import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GridApi, GridOptions, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { catchError, filter, map, of } from 'rxjs';

@Component({
  selector: 'app-carton-disposition-reports',
  templateUrl: './carton-disposition-reports.component.html',
  styleUrls: ['./carton-disposition-reports.component.scss']
})
export class CartonDispositionReportsComponent {
  apiUrl: string = '/api/carton_disposition_reports/carton_disposition_reports.php';
  gridApi!: GridApi;
  gridOptions: GridOptions = {};

  reports_form: FormGroup = this.fb.group({
    pickup_from: [''],
    pickup_to: [''],
    delivery_from: [''],
    delivery_to: [''],
  })

  constructor(private http: HttpClient, private fb: FormBuilder, private router: Router) {
    this.gridOptions = {
      rowModelType: 'serverSide',
      cacheBlockSize: 20,
      onGridReady: this.onGridReady.bind(this),
    }
  }

  ngOnInit(): void {
    // this.http.get(url).subscribe((response: any)=> {
    //   if(response) {
    //     console.log(response);
    //     this.stores = response.data.data;
    //   }
    // })
  }

  cartonColumnDefs = [
    { field: 'asn_number', headerName: 'ASN Number' },
    { field: 'store_number', headerName: 'Store Number' },
    { field: 'trip_number', headerName: 'Trip Number' },
    { field: 'week_no', headerName: 'Week No', filter: 'agNumberColumnFilter', valueGetter: (params: any) => {
      if(params.value == 'NaN') {
        return '';
      }
      else {
        return params.value
      }
    } },
    { field: 'trailer_id', headerName: 'Trailer ID', },
    { field: 'product_uuid', headerName: 'Product ID' },
    { field: 'created', headerName: 'Created', filter: 'agDateColumnFilter' },
    { field: 'modified', headerName: 'Modified', filter: 'agDateColumnFilter' },
    { field: 'return_status', headerName: 'Return Status', },
    { field: 'carton_resolution', headerName: 'Carton Resolution', },
    { field: 'barcode', headerName: 'Barcode', },
  ]

  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    resizable: true,
  }

  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getCartonReports(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              console.log('print out the response: ', response)
              if (response) {
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getCartonReports(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const apiUrl = this.apiUrl;
    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {

      let operator = '';
      let value = [];
      console.log('filter model', filterModel)
      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values; // Join selected values with a delimiter if needed
      } else if (filter.filterType === 'date') {
        if (filter.type == 'inRange') {
          operator = filter.type;
          value = [filter.dateFrom, filter.dateTo];
        }
        else {
          operator = 'equals';
          value = filter.dateFrom;
        }

      } else if (filter.filterType === 'number') {
        if (filter.type == 'inRange') {
          operator = filter.type;
          value = [filter.filter, filter.filterTo];
        }
        else {
          operator = 'equals';
          value = filter.filter;
        }
      }

      return {
        column,
        operator,
        value,
      };
    });

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };
    console.log('an array of filter object: ', filters)
    return this.http.get<any>(this.apiUrl, { params }).pipe(
      map((response) => {
        console.log('Message from the backend: ', response);
        const newData = response.data.data.map((item: any) => {
          // Convert the 'week_no' property to a number
          const week_no = parseInt(item.week_no, 10);

          // Return a new object with the converted 'week_no'
          return { ...item, week_no };
        });
        return {
          rowData: newData,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.setGridOption('serverSideDatasource',this.getServerSideDatasource());
  }

  onToggleButtonChange(event: any) {
    if (event.value == 'pickup') {
      this.reports_form.get('delivery_from')?.setValue('');
      this.reports_form.get('delivery_to')?.setValue('');
    }
    else if (event.value == 'delivery') {
      this.reports_form.get('pickup_from')?.setValue('');
      this.reports_form.get('pickup_to')?.setValue('');
    }
    else {
      console.log('Not valid.')
    }
  }

  //Reset the filter by setting to empty object
  resetFilter() {
    this.reports_form.get('pickup_from')?.setValue('');
    this.reports_form.get('pickup_to')?.setValue('');
    this.reports_form.get('delivery_from')?.setValue('');
    this.reports_form.get('delivery_to')?.setValue('');
    this.router.navigate(['/store_reports']);
  }

  search() {
    if (this.reports_form.get('pickup_from')?.value) {
      const pickup_from = this.formatDateAsYYYYMMDD(this.reports_form.get('pickup_from')?.value)
      const pickup_to = this.formatDateAsYYYYMMDD(this.reports_form.get('pickup_to')?.value)
      this.router.navigate(['/store_reports'], {
        queryParams: {
          pickup_from: pickup_from,
          pickup_to: pickup_to
        }
      });
    }
    else if (this.reports_form.get('delivery_from')?.value) {
      const delivery_from = this.formatDateAsYYYYMMDD(this.reports_form.get('delivery_from')?.value)
      const delivery_to = this.formatDateAsYYYYMMDD(this.reports_form.get('delivery_to')?.value)
      this.router.navigate(['/store_reports'], {
        queryParams: {
          delivery_from: delivery_from,
          delivery_to: delivery_to
        }
      });
    }
    else {
      console.log('Invalid.')
    }
  }

  formatDateAsYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getAllServerSideDatasource(type: string): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getCartonReports(0, 999999, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                console.log('this is the response: ', response)
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
                if(type == 'csv') {
                  this.gridApi.exportDataAsCsv({
                    fileName: 'Store_Report', // Change to the desired file name 
                  });  
                }
                else {
                  this.gridApi.exportDataAsExcel({
                    fileName: 'Store_Report', // Change to the desired file name 
                    sheetName: 'ulaap', // Change to the desired tab name 
                  });
                }
                
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  exportToCSV() {
    this.gridApi.setGridOption('serverSideDatasource',this.getAllServerSideDatasource('csv'));
    
  }

  exportToExcel() {
    this.gridApi.setGridOption('serverSideDatasource',this.getAllServerSideDatasource('excel'));
  }
}
